import { useEffect, useState } from "react";
import { BusinessAreaAddon, UploaderBusinessAreaEntity } from "./BusinessAreaAddon";
import { useCurrentOrganisationId } from "../../../../../../services/local/organisationContext/OrganisationContextModel";
import { GridTypes } from "../../../../../../enums";
import { BUSINESS_AREA_GRID_UPLOADER_CONFIG } from "../../../../../../core/grids/builder/directorBuilder/uploader/config/BusinessAreaGridUploader_config";
import toastService from "../../../../../../core/toaster/ToasterService";
import { TOASTER_TOAST_TIME } from "../../../../../../core/toaster/Toaster_model";
import I18n from "../../../../../../core/localization/I18n";
import { BusinessAreasGrid } from "../../../../../../core/grids/builder/directorBuilder/grids/BusinessAreasGrid/BusinessAreasGridView_view";
import { Button, ButtonTypes } from "../../../../Button";

export const BusinessAreaAddonView: React.FC<{
  uploadedData: any[];
  processedEntities: Record<string, any[]>;
  onComplete: (result: Partial<UploaderBusinessAreaEntity>[]) => void;
}> = ({ uploadedData, processedEntities, onComplete }) => {
  // eslint-disable-next-line
  const [existingAreas, setExistingAreas] = useState<Partial<UploaderBusinessAreaEntity>[]>([]);
  // eslint-disable-next-line
  const [extractedAreas, setExtractedAreas] = useState<Partial<UploaderBusinessAreaEntity>[]>([]);
  const [mappedAreas, setMappedAreas] = useState<Partial<UploaderBusinessAreaEntity>[]>([]);
  const [activeTab, setActiveTab] = useState<"mapping" | "new" | "matched">("mapping");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [editArea, setEditArea] = useState<Partial<UploaderBusinessAreaEntity> | null>(null);
  const organisaitonId = useCurrentOrganisationId();

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);

        const addon = new BusinessAreaAddon(
          () => {},
          () => {},
          {
            organisationId: organisaitonId,
            gridType: GridTypes.BUSINESS_AREAS_GRID,
            fields: BUSINESS_AREA_GRID_UPLOADER_CONFIG,
            registeredAddons: []
          }
        );

        const existingAreasData = await addon.getExistingEntities();
        setExistingAreas(existingAreasData);

        const extractedAreasData = addon.extractBusinessAreasFromData(uploadedData);
        setExtractedAreas(extractedAreasData);

        const mappedAreasData = await addon.mapEntities(uploadedData, existingAreasData);
        setMappedAreas(mappedAreasData);
      } catch (error) {
        console.error("Error loading business area data:", error);
        toastService
          .showErrorToast(TOASTER_TOAST_TIME.NORMAL, "right")
          .setContent(<span>Failed to load business area data</span>);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
    // eslint-disable-next-line
  }, [uploadedData]);

  // eslint-disable-next-line
  const handleMatchArea = (area: UploaderBusinessAreaEntity) => {
    // Implement matching logic - e.g., show a modal with existing areas
    console.log("Match area:", area);
  };

  // eslint-disable-next-line
  const handleCreateNew = (area: UploaderBusinessAreaEntity) => {
    const newArea = {
      ...area,
      isNew: true,
      isMatched: false
    };
    setEditArea(newArea);
  };

  // eslint-disable-next-line
  const handleSaveEdit = () => {
    if (!editArea) return;

    const updatedAreas = mappedAreas.map(area => (area === editArea || area.name === editArea.name ? editArea : area));

    setMappedAreas(updatedAreas);
    setEditArea(null);
  };

  const handleComplete = () => {
    onComplete(mappedAreas);
  };

  // todo: filter data based on active tab
  const getFilteredData = () => {
    switch (activeTab) {
      // case "new":
      //   return mappedAreas.filter(area => area.isNew);
      // case "matched":
      //   return mappedAreas.filter(area => area.isMatched);
      // case "mapping":
      default:
        return mappedAreas;
    }
  };

  return (
    <div className="col">
      <div className="row d-flex flex-column">
        <h3 className="">{I18n.t("phrases.businessAreaValidation")}</h3>
        <p>{I18n.t("phrases.businessAreaMapping")}</p>
      </div>

      <div className="row">
        <div className={`tab ${activeTab === "mapping" ? "active" : ""}`} onClick={() => setActiveTab("mapping")}>
          All ({mappedAreas.length})
        </div>
        <div className={`tab ${activeTab === "new" ? "active" : ""}`} onClick={() => setActiveTab("new")}>
          {/* New ({mappedAreas.filter(a => a.isNew).length}) */}
        </div>
        <div className={`tab ${activeTab === "matched" ? "active" : ""}`} onClick={() => setActiveTab("matched")}>
          {/* Matched ({mappedAreas.filter(a => a.isMatched).length}) */}
        </div>
      </div>

      <div className="row" style={{ height: "500px" }}>
        <BusinessAreasGrid data={getFilteredData()} isLoading={isLoading}></BusinessAreasGrid>
      </div>

      <div className="row d-flex justify-content-end mt-2">
        <Button className="mx-2" type={ButtonTypes.PRIMARY} isDisabled={isLoading} onClick={handleComplete}>
          <span>{`${I18n.t("phrases.next")}`}</span>
        </Button>
      </div>
    </div>
  );
};
